import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("ai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (p) => {
  if (!p) return "";
  return p.startsWith("http") ? p : `${API}/files/${p}`;
};

export const imgProps = (p, sizes = "100vw") => {
  const src = imgSrc(p);
  if (!p || p.startsWith("http") || !p.endsWith(".webp") || p.endsWith("_m.webp")) return { src };
  const mobile = `${API}/files/${p.replace(/\.webp$/, "_m.webp")}`;
  return { src, srcSet: `${mobile} 900w, ${src} 2000w`, sizes };
};

export const fileUrl = (storagePath, download = false) =>
  `${API}/files/${storagePath}${download ? "?download=1" : ""}`;

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload/image", form);
  return data;
}

export async function uploadTechFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload/file", form);
  return data;
}

export async function uploadVideo(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload/video", form);
  return data;
}

export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return err?.message || fallback;
}
